import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers }) => {
    const apiCalls = {
        carregarListaMenu(idUsuario) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Store/ListaMenu',
                responseType: 'json',                
                headers: headers,
                data: Helpers.aplicarValidacoes(idUsuario),
            });
        },
    }
    return apiCalls;
};